export interface ModulePermissionDef {
  key: string;
  label: string;
  group?: string;
}

export const MODULE_PERMISSIONS: { [moduleId: string]: ModulePermissionDef[] } = {
    dashboard: [
      { key: 'agent', label: 'Voir le statut Agent' }
    ],
    rh: [
      { key: 'manager', label: 'Manager (validation, catégories et tâches de l’équipe)', group: 'Rôle' }
    ],
    planning: [
      { key: 'manager', label: 'Manager (planning et congés de l’équipe)', group: 'Rôle' }
    ],
    playlist: [
      { key: 'view', label: 'Éditeur quotidien', group: 'Accès' },
      { key: 'generator', label: 'Générateur', group: 'Playlists' },
      { key: 'missing_files', label: 'Fichiers manquants', group: 'Playlists' },
      { key: 'statistics', label: 'Statistiques', group: 'Playlists' },
      { key: 'media_manager', label: 'Gestionnaire média', group: 'Playlists' },
      { key: 'settings', label: 'Paramètres', group: 'Playlists' }
    ],
    programming: [
      // Program Schedule (VIEW accessible à tous par défaut)
      { key: 'program_schedule_edit', label: 'Program Schedule - EDIT', group: 'Program Schedule' },
      { key: 'program_schedule_items', label: 'Program Schedule - ITEMS', group: 'Program Schedule' },
      { key: 'program_schedule_schedules', label: 'Program Schedule - SCHEDULES', group: 'Program Schedule' },
      
      // Ad Manager (VIEW accessible à tous par défaut)
      { key: 'ad_manager_edit', label: 'Ad Manager - ADS EDIT', group: 'Ad Manager' },
      { key: 'ad_manager_campaigns', label: 'Ad Manager - CAMPAIGNS', group: 'Ad Manager' },
      { key: 'ad_manager_billboards', label: 'Ad Manager - BILLBOARDS', group: 'Ad Manager' },
      { key: 'ad_manager_auto_promo', label: 'Ad Manager - AUTO PROMO', group: 'Ad Manager' },
      { key: 'ad_manager_advertisers', label: 'Ad Manager - ADVERTISERS', group: 'Ad Manager' },
      
      // Playlists (DAILY EDITOR accessible à tous par défaut)
      { key: 'playlists_generator', label: 'Playlists - GENERATOR', group: 'Playlists' },
      { key: 'playlists_missing_files', label: 'Playlists - MISSING FILES', group: 'Playlists' },
      { key: 'playlists_statistics', label: 'Playlists - STATISTICS', group: 'Playlists' },
      { key: 'playlists_media_manager', label: 'Playlists - MEDIA MANAGER', group: 'Playlists' },
      { key: 'playlists_settings', label: 'Playlists - SETTINGS', group: 'Playlists' }
    ],
    filemanager: [
      { key: 'shows', label: 'Shows' },
      { key: 'exports', label: 'Fichiers Export' },
      { key: 'rushs', label: 'Fichiers Rushs' },
      { key: 'hyperdeck', label: 'Hyperdeck → app dédiée' },
      { key: 'playlists', label: 'Playlists' },
      { key: 'drive', label: 'Drive Zitata' },
      { key: 'normalisation', label: 'Normalisation audio' },
      { key: 'replay', label: 'Transferts Replay' }
    ],
    hyperdeck: [
      { key: 'record', label: 'Lancer / arrêter les records', group: 'Enregistrement' },
      { key: 'status', label: 'Voir le statut des decks', group: 'Enregistrement' },
      { key: 'transfers', label: 'Transferts FTP → rushs', group: 'Transferts' },
      { key: 'markers', label: 'Accès markers (lecture)', group: 'Montage' }
    ],
    difizyon: [
      { key: 'view', label: 'Voir Difizyon (player, aperçu, playlist, logs)', group: 'Accès' },
      { key: 'playlists_edit', label: 'Modifier les playlists (IN/OUT, découpe, Programmation)', group: 'Playlists' },
      { key: 'media', label: 'Parcourir MEDIAS2 et glisser des fichiers', group: 'Playlists' },
      { key: 'insert_ad', label: 'Insérer une pub dans la journée', group: 'Playlists' },
      { key: 'live_control', label: 'Piloter l\'antenne (start, stop, clip suivant, Direct)', group: 'Antenne' },
      { key: 'output_window', label: 'Fenêtre de sortie', group: 'Antenne' },
      { key: 'settings', label: 'Réglages (chaîne, logo, Companion, DeckLink)', group: 'Administration' },
      { key: 'admin', label: 'Administrateur Difizyon (tous les droits)', group: 'Administration' }
    ],
    live: [
      { key: 'view', label: 'Live — voir le flux', group: 'Accès' },
      { key: 'record', label: 'Record — revoir l’enregistrement', group: 'Accès' },
      { key: 'admin', label: 'Admin — dashboard & encodeur', group: 'Accès' }
    ],
    alerting: [
      { key: 'view', label: 'Voir Alerting', group: 'Accès' },
      { key: 'manage', label: 'Gérer règles & recipients', group: 'Administration' }
    ],
    conducteur: [
      { key: 'view', label: 'Voir les conducteurs', group: 'Accès' },
      { key: 'edit', label: 'Éditer les conducteurs', group: 'Accès' },
      { key: 'runtime', label: 'Lecture', group: 'Exécution' },
      { key: 'start', label: 'Start antenne', group: 'Exécution' },
      { key: 'reset', label: 'Reset', group: 'Exécution' },
      { key: 'prompter', label: 'Accès prompteur', group: 'Exécution' },
      { key: 'create', label: 'Créer des conducteurs', group: 'Gestion' },
      { key: 'delete', label: 'Supprimer des conducteurs', group: 'Gestion' }
    ],
    magasin: [
      { key: 'view', label: 'Voir l\'inventaire', group: 'Accès' },
      { key: 'edit', label: 'Modifier les équipements', group: 'Gestion' },
      { key: 'create', label: 'Ajouter des équipements', group: 'Gestion' },
      { key: 'delete', label: 'Supprimer des équipements', group: 'Gestion' },
      { key: 'packs', label: 'Gérer les packs', group: 'Packs' },
      { key: 'photos', label: 'Gérer les photos', group: 'Médias' }
    ],
    vault: [
      { key: 'view', label: 'Voir les secrets', group: 'Accès' },
      { key: 'create', label: 'Créer des secrets', group: 'Gestion' },
      { key: 'edit', label: 'Modifier les secrets', group: 'Gestion' },
      { key: 'delete', label: 'Supprimer des secrets', group: 'Gestion' },
    ],
    rustdesk: [
      { key: 'view', label: 'Voir les sessions et connexions', group: 'Accès' },
      { key: 'admin', label: 'Gérer les appareils (nommer)', group: 'Administration' }
    ],
    bescor: [
      { key: 'view', label: 'Voir les têtes et statuts', group: 'Accès' },
      { key: 'control', label: 'Contrôler les têtes PTZ', group: 'Contrôle' }
    ],
    clim: [
      { key: 'view', label: 'Voir les zones et leur statut', group: 'Accès' },
      { key: 'control', label: 'Allumer / éteindre la climatisation', group: 'Contrôle' }
    ],
    timer: [
      { key: 'view', label: 'Accès au timer émissions (2 régies)', group: 'Accès' }
    ],
    appconsole: [
      { key: 'view', label: 'Voir le tableau de bord (stats)', group: 'Accès' },
      { key: 'contests', label: 'Gérer les jeux concours & participations', group: 'Gestion' },
      { key: 'push', label: 'Envoyer des notifications push', group: 'Notifications' }
    ],
    portal: [
      { key: 'access', label: 'Accès au portail', group: 'Accès' },
      { key: 'canRequestReservation', label: 'Demander des réservations', group: 'Réservations' },
      { key: 'conducteur_view', label: 'Voir le conducteur', group: 'Conducteur' }
    ],
    volumes: [
      { key: 'view', label: 'Voir le moniteur de volumes', group: 'Accès' },
      { key: 'remount', label: 'Remonter les volumes', group: 'Actions' },
      { key: 'restart_services', label: 'Redémarrer les services Docker', group: 'Actions' }
    ],
    network: [
      { key: 'view', label: 'Voir la cartographie réseau', group: 'Accès' },
      { key: 'edit', label: 'Modifier les équipements et switchs', group: 'Gestion' },
      { key: 'admin', label: 'Administration complète', group: 'Administration' }
    ],
    postiz: [
      { key: 'view', label: 'Accès à la plateforme de publication (Postiz)', group: 'Accès' }
    ],
    contacts: [
      { key: 'view', label: 'Voir le carnet d\'invités', group: 'Accès' },
      { key: 'edit', label: 'Modifier / supprimer des invités', group: 'Gestion' }
    ],
    lexique: [
      { key: 'conventions', label: 'Voir les conventions de nommage', group: 'Accès' },
      { key: 'lexique', label: 'Voir le champs lexical', group: 'Accès' },
      { key: 'edit', label: 'Ajouter / modifier le champs lexical', group: 'Gestion' },
      { key: 'add', label: 'Ajouter une convention ou une catégorie', group: 'Conventions' },
      { key: 'modify', label: 'Modifier / supprimer conventions et catégories', group: 'Conventions' },
      { key: 'move', label: 'Déplacer conventions et catégories', group: 'Conventions' }
    ],
    extraits: [
      { key: 'full', label: 'Accès complet', group: 'Accès' },
      { key: 'suivi', label: 'Accès au bouton Suivi', group: 'Accès' }
    ],
    regie_pub: [
      { key: 'view', label: 'Voir l\'app Régie Pub', group: 'Accès' },
      { key: 'edit', label: 'Modifier le CRM (comptes, contacts, activités, documents)', group: 'CRM' },
      { key: 'proposals', label: 'Créer et envoyer des propositions', group: 'Commercial' },
      { key: 'campaigns', label: 'Gérer les campagnes spots / billboards', group: 'Commercial' }
    ],
    achats: [
      { key: 'view', label: 'Voir les listes autorisées', group: 'Accès' },
      { key: 'dashboard', label: 'Voir le tableau de bord de tous les achats', group: 'Accès' },
      { key: 'edit', label: 'Créer et modifier les listes et les lignes', group: 'Gestion' }
    ],
    captations: [
      { key: 'view', label: 'Voir les dossiers autorisés et cocher le matériel préparé', group: 'Accès' },
      { key: 'edit', label: 'Créer les dossiers, le matériel, les notes, photos et fichiers', group: 'Gestion' }
    ],
    redaction_jt: [
      { key: 'view', label: 'Voir NiouZ (veille, rédacteur, sujets, conducteur, prompteur)', group: 'Accès' },
      { key: 'edit_veille', label: 'Veille : retenir, ignorer, lancer, régler les horaires', group: 'Veille' },
      { key: 'edit_rec', label: 'Rédacteur : lancer, réordonner, Prêt, lier une vidéo', group: 'Rédacteur' },
      { key: 'edit_script', label: 'Éditer un sujet (script, Zi Bot, prendre la main)', group: 'Rédaction' },
      { key: 'edit_correction', label: 'Prendre la main et passer un sujet en Prêt', group: 'Rédaction' },
      { key: 'valider_conducteur', label: 'Réordonner le conducteur', group: 'Conducteur' },
      { key: 'admin_robot', label: 'Générer / éditer / activer les répliques Zi Bot', group: 'Zi Bot' },
      { key: 'edit_settings', label: 'Accéder au menu Réglages (roue crantée)', group: 'Réglages' },
      { key: 'redacteur_en_chef', label: 'Rédacteur en chef : matière, voix off et affectation des tâches', group: 'Rédacteur' }
    ]
  };

